export default __webpack_public_path__ + "static/media/malwarebytes.594e997f.svg";